import React, { lazy, Suspense, memo } from "react";
import { useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import Loading from "components/shared-components/Loading";
import { lightTheme, darkTheme } from "configs/ThemeConfig";
import useBodyClass from "utils/hooks/useBodyClass";
import Routes from "routes";
import ErrorBanner from "components/shared-components/ErrorBanner";
import { useGetNotification } from "NotificationContext";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  useBodyClass(`dir-${direction}`);

  const themeConfig =
    currentTheme === "light" ? { ...lightTheme } : { ...darkTheme };

  const { unpaid } = useGetNotification();

  return (
    <ConfigProvider theme={themeConfig} direction={direction} locale={"id"}>
      <ErrorBanner />
      <Suspense fallback={<Loading cover="content" />}>
        <div style={{ marginTop: unpaid?.unpaid_total > 0 ? 40 : 0 }}>
          <Layout>
            <Routes />
          </Layout>
        </div>
      </Suspense>
    </ConfigProvider>
  );
};

export default memo(Layouts);
